import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Column, Row } from '@simplywallst/ui-core';
import { sectionHeading } from '../../styled';

interface FeatureProps {
  bgColor: string;
}

export const TeamContainerRow = styled(Row)<FeatureProps>`
  background: ${({ bgColor }) => `${bgColor}`};
  width: 100%;
  padding-bottom: ${({ theme }) => theme.x4spacePx}px;
`;

export const TeamHeader = styled.div`
  margin: ${({ theme }) => theme.x4spacePx}px;
  ${media.lgUp`
    max-width: 650px;
    margin: ${({ theme }) => theme.x7spacePx}px auto
      ${({ theme }) => theme.x4spacePx}px;
  `}
  text-align: center;
  h2 {
    ${sectionHeading}
  }
  p {
    ${({ theme }) => theme.typography.large};
    color: ${({ theme }) => theme.color.spaceGray};
    margin-bottom: 0px;
  }
`;

export const TeamImageRow = styled(Row)`
  padding: ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    padding: 0;
  `}
  ${media.lgOnly`
    padding: ${({ theme }) => theme.x4spacePx}px ${({ theme }) =>
      theme.x2spacePx}px;
    margin: 0;
  `}
`;

export const TeamImageColumn = styled(Column)`
  max-height: 270px;
  padding: 0 ${({ theme }) => theme.x1spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  ${media.mdUp`
    padding: ${({ theme }) => theme.x2spacePx}px
      ${({ theme }) => theme.x1spacePx}px;
  `}
  img {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    object-fit: cover;
  }
`;
